import { Button, Dialog, DialogActions, 
  DialogBody, DialogContent, DialogSurface, DialogTitle, 
  DialogTrigger, Field, Input, Label, ProgressBar, 
  Spinner, Title1, makeStyles, mergeClasses, shorthands, 
  MessageBar,
  MessageBarTitle,
  MessageBarBody,
  Link,
  MessageBarActions,
  Switch,
  Dropdown,
  Option,
  Divider,
  Subtitle1,
  TagPicker,
  TagPickerControl,
  TagPickerGroup,
  Tag,
  Avatar,
  TagPickerInput,
  RadioGroup,
  Radio,
  Text,
  Body1,
  Title2,
  Subtitle2,
  Title3
   } from '@fluentui/react-components';
import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  DismissRegular,
  Box24Regular,
  ClipboardMonth20Regular,
  DataUsage20Regular,
  Mail20Regular,
  Person20Regular,
  ReceiptMoney20Regular,
  Payment20Regular,
  Calendar20Regular,
  ArrowDownFilled
  } from "@fluentui/react-icons";

import { useMsal, useAccount } from '@azure/msal-react';
import { silentRequest } from '../../authConfig';
import axios from 'axios';
import { useLocation, useHistory } from 'react-router-dom';
import { makeDecimalNumber } from '../../helpers/NumberFunction';
import { checkEmail } from '../../helpers/CheckEmail';

const homeStyles = {
  border: 0,
  margin: 0,
  width: '100%',
  minWidth: 'calc(100vw - 310px)',
  background: '#FAF9F8',
  position: 'relative',
};

const useStyles = makeStyles({
  root: {
      display: "flex",
      flexDirection: "column",
      width: "670px",
  },
  card: {
      display: "flex",
      backgroundColor: "#fff",
      ...shorthands.gap("20px"),
      // justifyContent: "center",
      alignItems: "center",
      ...shorthands.padding("20px", "0px"),
      boxShadow: "rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px",
      ...shorthands.borderRadius("10px"),
      width: "310px",
      height: "310px",
      transition: 'transform 0.3s ease, box-shadow 0.3s ease', // Smooth transition for scaling and shadow
      // boxSizing: 'border-box',
      cursor: 'pointer', // Indicates interactivity
      '&:hover': {
        transform: 'scale(1.05)', // Expands the item on hover
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)', // Adds a shadow effect
      }
  },
  userDetail: {
      ...shorthands.border("2px", "solid", "#ccc"),
      ...shorthands.overflow("hidden"),
      display: "flex",
      height: "400px",
      width: "505px",
      ...shorthands.padding("10px", "20px"),
      ...shorthands.borderRadius("10px"),
  },
  paymentDetail: {
      ...shorthands.border("2px", "solid", "#ccc"),
      ...shorthands.overflow("hidden"),
      display: "flex",
      height: "400px",
      width: "319px",
      ...shorthands.padding("10px", "20px"),
      ...shorthands.borderRadius("10px")
  },
  flex: {
    display: "flex", 
    justifyContent: "end", 
    alignItems: "center",
    ...shorthands.gap("20px"),
  },
  flexLeft: {
    display: "flex", 
    justifyContent: "start", 
    alignItems: "center",
    ...shorthands.gap("5px"),
  },
  contentSpacing: {
    display: "flex", 
    alignItems: "center",
    ...shorthands.gap("5px"),
  },
  stack: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    width: 'auto',
    height: 'auto',
    boxSizing: 'border-box',
    '> *': {
      textOverflow: 'ellipsis',
    },
    '> :not(:first-child)': {
      marginTop: '0px',
    },
    '> *:not(.ms-StackItem)': {
      flexShrink: 1,
    },
  },
  vertical: {
    display: 'flex',
    flexDirection: 'column',
  },
  // verticalCenter: {
  //   display: 'flex',
  //   alignItems: "center"
  // },
  fullWidth: {
    width: "100%"
  },
  spaceBetween: {
    justifyContent: "space-between"
  },
  columnGap: {
    ...shorthands.gap("0px", "10px"),
  },
  rowGap: {
    ...shorthands.gap("10px", "0px"),
  },
  horizontalCenter: {
    display: "flex",
    justifyContent: "center"
  },
  horizontalSpaceBetween: {
    display: "flex",
    justifyContent: "space-between"
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    rowGap: "10px",
  },
  verticalCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
});

const toThaiDateString = (isoDateTime) => {
  let date = '';
  date = new Date(isoDateTime);
  let year = date.getFullYear() + 543;
  let month = (date.getMonth() + 1).toString().padStart(2, '0');
  let numOfDay = date.getDate().toString().padStart(2, '0');

  let hour = date.getHours().toString().padStart(2, '0');
  let minutes = date.getMinutes().toString().padStart(2, '0');
  let second = date.getSeconds().toString().padStart(2, '0');

  return `${numOfDay}/${month}/${year} ${hour}:${minutes}:${second} น.`;
};

const API_URL = process.env.REACT_APP_API_URL;

const BillingType = () => {
  const history = useHistory();
  const location = useLocation();

  const { t, i18n } = useTranslation();

  const styles = useStyles();

  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const [loading, setLoading] = useState(true)

  const companyId = sessionStorage.getItem('companyId') || '';

  useEffect(() => {
    async function getPackage() {
      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios.get(`${API_URL}/packages/current`, {
          headers: {
            Authorization: 'Bearer ' + tokenResponse.accessToken,
            'cid': companyId,
          },
        }).then(async (responseCurrentPackage) => {
          if (responseCurrentPackage.data) {
            const statementResponse = await axios.get(`${API_URL}/documents/billings?status=open`, {
                                      headers: {
                                        Authorization: 'Bearer ' + tokenResponse.accessToken,
                                        'cid': companyId,
                                      },
                                    })

            const documents = statementResponse.data.data?.documents || []

            const unpaidDocuments = documents.filter(_doc => {
              if (_doc.data.billing?.disabledCancel) {
                return true
              }

              const isoTimeNow = new Date().toISOString()
              if (_doc.data.dueDate && isoTimeNow > _doc.data.dueDate) {
                return false
              }

              return true
            })

            const _currentPackage = responseCurrentPackage.data
            if (_currentPackage.trial && unpaidDocuments.length) {
              history.push({
                pathname: '/payments',
                state: {},
              });
            } else {
              setLoading(false)
            }
          }
        })
        
      })
    }

    getPackage()
  }, [])

  const handleGoNext = (billingType) => {
    if (billingType === 'etax') {
      history.push({
        pathname: '/billings',
        state: {},
      });
    } else {
      history.push({
        pathname: '/packages',
        state: {
          billingType: 'paper'
        },
      });
    }
  }

  return <div style={homeStyles}>
    <div style={{ display: "flex", justifyContent: "center"}}>
      {loading ? (
        <div style={{ display: "flex", alignContent: "center", height: "100%", width: "100%", justifyContent: "center", marginTop: 21}}>
          <Spinner labelPosition="below" label={t(`packageDetail.loading`)} />
        </div>
      ) : (
        <div className={styles.root} style={{ alignItems: "center"}}>
          <Title1 as='h1' style={{ marginBottom: 0}}>
            <div style={{ display: "flex", flexDirection: "row"}}>
              <div>{t("billingType.header1")}</div>
            </div>
          </Title1>
          <Title2 as='h2' style={{ marginTop: 0, marginBottom: 25}}>
            <div style={{ display: "flex", flexDirection: "row"}}>
              <div className={styles.verticalCenter}>
                <div>{t("billingType.header2")}</div>
              </div>
            </div>
          </Title2>
          <div style={{ display: "flex", flexDirection: "row", gap: 20}}>
            <div className={mergeClasses(styles.card, styles.vertical)} onClick={() => handleGoNext("paper")}>
              <div>
                <Subtitle1>
                  {t("billingType.package")}

                </Subtitle1>
              </div>
              <div style={{ width: "100%"}}>
              <Divider />

              </div>
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%", alignItems: "center"}}>
                <div>
                  <Subtitle1>
                    {t("billingType.documentType")}

                  </Subtitle1>
                </div>
                <div>
                  <Title1 as='h1' style={{ color: "#0078d4"}}>
                    {t("billingType.paper")}

                  </Title1>
                </div>
                <div>
                  <Button appearance="primary" size='large' onClick={() => handleGoNext("paper")}>
                    {t("billingType.select")}
                  </Button>
                </div>

              </div>
            </div>
            <div className={mergeClasses(styles.card, styles.vertical)} onClick={() => handleGoNext("etax")}>
              <div>
                <Subtitle1>
                  {t("billingType.package")}

                </Subtitle1>
              </div>
              <div style={{ width: "100%"}}>
              <Divider />

              </div>
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "150%", alignItems: "center"}}>
                <div>
                  <Subtitle1>
                    {t("billingType.documentType")}

                  </Subtitle1>
                </div>
                <div>
                  <Title3 style={{ color: "#0078d4"}}>
                    e-Tax Invoice & e-Receipt
                  </Title3>
                </div>
                <div>
                  <Button appearance="primary" size='large' onClick={() => handleGoNext("etax")}>
                    {t("billingType.select")}
                  </Button>
                </div>

              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
};

export default BillingType;
